<template>
	<div class="vipbilllist">
		<el-card class="vipbill" :style="{ height: `${windowHeight}px` }">
			<el-tabs v-model="tabName" @tab-click="GetTabData">
				<el-tab-pane :label="tab.name" :name="tab.name" v-for="tab in tabs" :key="tab.l_id">
					<span slot="label">{{ tab.name }} ({{ tab.count }})</span>
					<el-row>
						<el-form :inline="true" class="demo-form-inline">
							<el-col :span="7" style="color:transparent">1</el-col>
							<el-col :span="10">
								<el-form-item label="操作时间" style="padding:0px;">
									<el-date-picker
										v-model="timerange"
										type="daterange"
										align="right"
										unlink-panels
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期"
										size="small"
										@change="datachange"
										:editable="false"
										:picker-options="pickerOptions"
									></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="快速搜索" style="padding:0px;">
									<el-input placeholder="搜索订单号" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input>
								</el-form-item>
							</el-col>
						</el-form>
					</el-row>
					<el-row>
						<el-col :span="24">
							<tableui
								style="width:100%;margin-top:-10px"
								v-loading="loading"
								ref="vipbillable"
								:tableData="vipbilllist"
								:columns="tab.columns"
								:gridheight="gridheight"
								@gridsort="gridsort"
								@checkboxchange="checkboxchange"
								@gridscroll="gridscroll"
								:istop="istop"
								@cellclick="cellclick"
							></tableui>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			istop: false,
			searchlist: {
				starttime: '',
				endtime: ''
			},
			vipaccount: localStorage.getItem('vipaccount'),
			windowHeight: window.innerHeight - 120,
			searchbox: '',
			activeTabIndex: 0, //激活的选项卡index
			tabName: '',
			vipbilllist: [],
			gridheight: (window.innerHeight * 65) / 100 + 'px',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '会员卡明细', //当前操作的功能模块名称
			selectedall: false,
			checkedrow: [],
			list: '',
			batch: '',
			timerange: [],
			pickerOptions: {
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			}
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/vipbill.scss');
			this.getTabs();
		});
		var that = this;
		this.tabName='';
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
		if (this.urlparam != undefined) {
			if (this.urlparam.vipaccount != undefined) {
				this.vipaccount = this.urlparam.vipaccount;
			}
			if (this.urlparam.type != undefined) {
				this.tabName = this.urlparam.type;
			}
		}
		if (this.vipaccount == '') this.vipaccount = localStorage.getItem('vipaccount');
		// this.searchlist.starttime = this.$tool.getcurrentday();
		// this.searchlist.endtime = this.$tool.getcurrentday();
		//this.timerange = [this.$tool.getcurrentday(), this.$tool.getcurrentday()];
	},
	methods: {
		// init(){
		// 	if(this.tabs.length==0)
		// 		this.getTabs();
		// 	else
		// 	{
		// 		var i=0;
		// 		this.tabs.forEach(e=>{
		// 			if(e.name==this.tabName)
		// 				this.activeTabIndex=i;
		// 			else
		// 				i++;
		// 		});
		// 		if(this.tabName=='')
		// 			this.tabName = this.tabs[this.activeTabIndex].name;
		// 		this.GetTabData();
		// 	}
		// },
		//获取选项卡
		getTabs() {
			var that=this;
			this.$apipost.get.GetTabs({ parentid: 98 }).then(res => {
				that.tabs = res.tabs;
				if (that.tabs.length > 0){
					var i=0;
					that.tabs.forEach(e=>{
						if(e.name==that.tabName)
							that.activeTabIndex=i;
						else
							i++;
					});
					if(that.tabName=='')
						that.tabName = that.tabs[that.activeTabIndex].name;
				}
				that.GetTabData();
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				starttime: '',
				endtime: ''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
			}

			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 84) {
					that.refreshgrid(false);
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			this.istop = false;
			if (isrefresh) {
				this.vipbilllist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.istop = true;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			this.vipbilllist=[];
			if (isload) {
				this.loading = true;
				var paraminfo = {
					search: this.GetSearchObj(),
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					tab: this.tabs[this.activeTabIndex].type,
					userid: localStorage.getItem('userid'),
					mode: this.mode,
					vipaccount: this.vipaccount
				};
				console.log('获取列表', JSON.stringify(paraminfo));
				//if(1>0) return false;
				this.$apipost.get
					.VipBill({
						paraminfo: paraminfo
					})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.vipbilllist = that.vipbilllist.concat(res.data);
							} else {
								that.vipbilllist = res.data;
							}
						}
					});
			}
			this.GetCount(); //获取汇总数
		},
		GetCount() {
			var that = this;
			var paraminfo = {
				search: this.GetSearchObj(),
				vipaccount: this.vipaccount
			};
			console.log('获取总数', JSON.stringify(paraminfo));
			//if(1>0) return false;
			this.$apipost.get.GetVipBillCount({ paraminfo: paraminfo }).then(res => {
				if (res.state == '1') {
					for (var i = 0; i < that.tabs.length; i++) {
						var countlist = res.countlist[0];
						for (var e in countlist) {
							if (e == that.tabs[i].type) {
								that.tabs[i].count = countlist[e];
								break;
							}
						}
					}
					that.setpagecount();
				}
			});
		},
		//设置分页显示数
		setpagecount() {
			var tabs = this.tabs;
			tabs.forEach(e => {
				if (parseInt(e.count) % this.pagesize == 0) {
					e.pagecount = parseInt(e.count) / this.pagesize;
				} else {
					e.pagecount = parseInt(parseInt(e.count) / this.pagesize) + 1;
				}
			});
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 0, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		//列表排序
		gridsort(e) {
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		datachange(e) {
			if(e!=null){
				this.searchlist.starttime = this.$tool.getcurrentday(e[0]);
				this.searchlist.endtime = this.$tool.getcurrentday(e[1]);
			}
			else{
				this.searchlist.starttime='';
				this.searchlist.endtime='';
			}
			this.refreshgrid(true);
		},
		cellclick(e){
			if(e.event=='openurl')
			{
				if(e.column.field=='p_pkval'){
					Utils.$emit('handleRermove','订单详情');
					var value=e.row[e.column.field];
					setTimeout(function(){
						Utils.$emit('go', { l_url: '/packagemanage/orderdetail',l_id:76,l_name:'订单详情', urlparam: {pkval:value} });
					},200); 
				}
			}
		}
	}
};
</script>
